import React from 'react'
import { Form } from 'semantic-ui-react'
import { Field } from 'react-final-form'
import { ProductLocalizedKeys } from '../form/types'
import { Photos } from '../../Products/Form/Photos/Photos'

export const Images = ({ product }: { product: Pick<ProductLocalizedKeys, 'image_urls'> }) => (
  <Form.Field>
    <Field name="image_urls">
      {({ input: { onChange, value } }) => (
        <Photos onChange={onChange} image_urls={value} productImageUrls={product.image_urls} />
      )}
    </Field>
  </Form.Field>
)
